import { Search, CreditCard, Calendar, Shield, BarChart3, Settings } from 'lucide-react';

export function FeatureHighlights() {
  const features = [
    {
      icon: Search,
      title: 'smart search',
      description: 'find courses by location, price, difficulty, and amenities'
    },
    {
      icon: CreditCard,
      title: 'secure payments',
      description: 'safe transactions with automatic refunds and transparent pricing'
    },
    {
      icon: Calendar,
      title: 'flexible scheduling',
      description: 'book instantly or reserve future tee times with calendar integration'
    },
    {
      icon: Settings,
      title: 'tee time configuration',
      description: 'course owners can customize available time slots and control traffic flow'
    },
    {
      icon: Shield,
      title: 'verified courses',
      description: 'all courses are verified and reviewed by our community'
    },
    {
      icon: BarChart3,
      title: 'analytics dashboard',
      description: 'track your earnings, bookings, and course performance in real-time'
    }
  ];

  return (
    <section id="features" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground lowercase mb-4">
            powerful <span className="text-primary">features</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            everything you need to find, book, and manage disc golf experiences
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group p-6 bg-gradient-to-br from-accent/50 to-muted/30 rounded-2xl hover:from-primary/5 hover:to-primary/10 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10 hover:-translate-y-1"
              >
                <div className="mb-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all duration-300">
                    <Icon className="w-6 h-6 text-primary group-hover:text-white" />
                  </div>
                </div>
                
                <div className="space-y-2">
                  <h3 className="text-lg font-bold text-foreground lowercase">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>

                {/* Hover Effect */}
                <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="h-0.5 w-full bg-gradient-to-r from-primary to-transparent rounded-full" />
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-4">
            and many more features coming soon...
          </p>
          <div className="flex justify-center space-x-2">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce delay-100" />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce delay-200" />
          </div>
        </div>
      </div>
    </section>
  );
}